import flatpickr from 'flatpickr';
import l10n from 'flatpickr/dist/l10n/de.js';
import './BookingOverlayButton';

const bookinkOverlay = () => {
    const bookingOverlay = document.querySelector('.booking-overlay');
    if (!bookingOverlay) {
        return;
    }

    const closeBookingOverlayButton = bookingOverlay.querySelector(
        '.booking-overlay__close'
    );
    const bookFromButton = bookingOverlay.querySelector(
        '.booking-overlay__picker-from'
    );
    const bookToButton = bookingOverlay.querySelector(
        '.booking-overlay__picker-to'
    );
    const dateFrom = bookingOverlay.querySelector(
        '.booking-overlay__picker-date-from'
    );
    const dateTo = bookingOverlay.querySelector(
        '.booking-overlay__picker-date-to'
    );
    const yearFrom = bookingOverlay.querySelector(
        '.booking-overlay__picker-year-from'
    );
    const yearTo = bookingOverlay.querySelector(
        '.booking-overlay__picker-year-to'
    );
    const buttonBook = bookingOverlay.querySelector(
        '.booking-overlay__button-book'
    );
    const buttonRequest = bookingOverlay.querySelector(
        '.booking-overlay__button-request'
    );
    const dateFormat = bookingOverlay.dataset.dateFormat;
    const lang = bookingOverlay.dataset.lang;

    function hideBookingOverlay() {
        if (window.localStorage) {
            window.localStorage.removeItem('overlayIsVisible');
            window.localStorage.setItem('overlayIsVisible', false);
        }
        bookingOverlay.classList.add('booking-overlay--block-hidden');
    }

    function showBookingOverlay() {
        bookingOverlay.classList.remove('booking-overlay--block-hidden');
    }

    function getIsoDate(date) {
        if (!(date instanceof Date)) {
            return '';
        }

        // do not utilize `toISOString()` (UTC) here to prevent timezone conversion issues
        return (
            date.getFullYear() +
            '-' +
            String(date.getMonth() + 1).padStart(2, 0) +
            '-' +
            String(date.getDate()).padStart(2, 0)
        );
    }

    /**
     * Poor mans moment.js with only "d" and "m"
     */
    function getFormattedDate(date) {
        if (!(date instanceof Date)) {
            return '&nbsp;';
        }
        let month = date.getMonth() + 1;
        let day = date.getDate();
        return dateFormat.replace('d', day).replace('m', month);
    }

    /**
     * Show the year only if it's not the current year
     */
    function getFormattedYear(date) {
        if (!date) {
            return '&nbsp;';
        }
        return date.getFullYear();
    }

    function redirectToBookingPage(fromDate, untilDate) {
        if (
            window.__GGBookingUri &&
            fromDate instanceof Date &&
            untilDate instanceof Date
        ) {
            window.location.href = window.__GGBookingUri;

            if (window.location.href.split('#')[0] === window.__GGBookingUri) {
                location.reload(true);
            }
        }
    }

    function redirectToInquiryPage(fromDate, untilDate) {
        if (
            window.__GGInquiryUri &&
            fromDate instanceof Date &&
            untilDate instanceof Date
        ) {
            // as of now we do not know about any API endpoint
            // to pass a from and an until date to the inquiry form
            window.location.href =
                window.__GGInquiryUri +
                '?arrivalDate=' +
                getIsoDate(fromDate) +
                '&departureDate=' +
                getIsoDate(untilDate);

            if (window.location.href.split('#')[0] === window.__GGInquiryUri) {
                location.reload(true);
            }
        }
    }

    function storeDates(fromDate, untilDate) {
        window.localStorage.setItem('bookingOverlayFromDate', fromDate);
        window.localStorage.setItem('bookingOverlayUntilDate', untilDate);
    }

    function getStoredDate(identifier) {
        if (window.localStorage.getItem(identifier)) {
            const rememberedFromDate = new Date(
                window.localStorage.getItem(identifier)
            );

            if (rememberedFromDate.getTime() > new Date().getTime()) {
                return rememberedFromDate;
            }
        }
        return null;
    }

    const flatpickrConfig = {
        mode: 'range',
        minDate: 'today',
        appendTo: bookingOverlay,
        defaultDate: getFlatpickrDefaultDate(),
        onReady: function() {
            dateFrom.innerHTML = getFormattedDate(this.selectedDates[0]);
            dateTo.innerHTML = getFormattedDate(this.selectedDates[1]);
            var currentYear = new Date().getFullYear();
            let showYear =
                (this.selectedDates[0] &&
                    getFormattedYear(this.selectedDates[0]) !== currentYear) ||
                (this.selectedDates[1] &&
                    getFormattedYear(this.selectedDates[1]) !== currentYear);
            yearFrom.innerHTML = showYear
                ? getFormattedYear(this.selectedDates[0])
                : '';
            yearTo.innerHTML = showYear
                ? getFormattedYear(this.selectedDates[1])
                : '';
        },
        onValueUpdate: function(selectedDates, dateStr) {
            dateFrom.innerHTML = getFormattedDate(selectedDates[0]);
            dateTo.innerHTML = getFormattedDate(selectedDates[1]);

            storeDates(selectedDates[0], selectedDates[1]);
            var currentYear = new Date().getFullYear();
            let showYear =
                (selectedDates[0] &&
                    getFormattedYear(selectedDates[0]) !== currentYear) ||
                (selectedDates[1] &&
                    getFormattedYear(selectedDates[1]) !== currentYear);
            yearFrom.innerHTML = showYear
                ? getFormattedYear(selectedDates[0])
                : '';
            yearTo.innerHTML = showYear
                ? getFormattedYear(selectedDates[1])
                : '';
        }
    };

    function getFlatpickrDefaultDate() {
        const defaultFromDate = new Date(
            new Date().getTime() + 24 * 60 * 60 * 1000 * 8
        );
        const defaultUntilDate = new Date(
            new Date().getTime() + 24 * 60 * 60 * 1000 * 15
        );

        const fromDate =
            getStoredDate('bookingOverlayFromDate') || defaultFromDate;
        const untilDate =
            getStoredDate('bookingOverlayUntilDate') || defaultUntilDate;

        return [fromDate, untilDate];
    }

    // init
    if (lang == 'de') {
        flatpickr.localize(l10n.de);
    }
    var datepicker = flatpickr(bookFromButton, flatpickrConfig);
    bookToButton.addEventListener('click', () => {
        datepicker.setDate([datepicker.selectedDates[0]]);
        datepicker.open();
    });

    bookingOverlay.addEventListener(
        'showBookingOverlay',
        showBookingOverlay,
        false
    );
    closeBookingOverlayButton.addEventListener('click', hideBookingOverlay);
    buttonBook.addEventListener('click', () => {
        redirectToBookingPage(
            datepicker.selectedDates[0],
            datepicker.selectedDates[1]
        );
    });
    buttonRequest.addEventListener('click', () => {
        redirectToInquiryPage(
            datepicker.selectedDates[0],
            datepicker.selectedDates[1]
        );
    });
};

export default bookinkOverlay;
